/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTeamStatistics = /* GraphQL */ `
  query GetTeamStatistics($id: ID!) {
    getTeamStatistics(id: $id) {
      id
      teamId
      team {
        id
        name
        country
        logo
        teamStats {
          nextToken
        }
        venueName
        createdAt
        updatedAt
      }
      competitionId
      goalsFor
      season {
        standings
      }
      goalsAgainst
      form
      fixtures
      createdAt
      updatedAt
    }
  }
`;
export const getPlayer = /* GraphQL */ `
  query getPlayer($id: ID!) {
    getPlayer(id: $id) {
      age
      birthCountry
      birthDate
      birthPlace
      createdAt
      height
      weight
      id
      firstname
      lastname
      shortName
      nationality
      number
      photo
      position
      team {
        id
        name
        country
        logo
        teamStats {
          items {
            teamId
            competitionId
            competition {
              id
              name
              logo
              type
            }
            playerStats
          }
        }
      }
    }
  }
`;
export const listTeamStatisticss = /* GraphQL */ `
  query ListTeamStatisticss(
    $filter: ModelTeamStatisticsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeamStatisticss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        teamId
        team {
          id
          name
          country
          logo
          createdAt
          updatedAt
        }
        competitionId
        goalsFor
        goalsAgainst
        form
        fixtures
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTeam = /* GraphQL */ `
  query getTeam($id: ID!) {
    getTeam(id: $id) {
      id
      name
      country
      logo
      players {
        items {
          id
          position
          photo
          firstname
          shortName
          lastname
          number
        }
      }
      # coach
      teamStats {
        items {
          id
          teamId
          competitionId
          competition {
            name
            logo
            type
          }
          goalsFor
          goalsAgainst
          season {
            year
            standings
            updatedAt
          }
          form
          fixtures
          allFixtures
          goalsPerMin
          playerStats
          cleanSheet
          updatedAt
        }
        nextToken
      }
      venueName
      futureGames
      prevGames
      updatedAt
    }
  }
`;
export const listTeams = /* GraphQL */ `
  query listTeams($filter: ModelTeamFilterInput, $limit: Int, $nextToken: String) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        logo
        priority
      }
      nextToken
    }
  }
`;
export const listPlayers = /* GraphQL */ `
  query listPlayers($filter: ModelPlayerFilterInput, $limit: Int, $nextToken: String) {
    listPlayers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        shortName
        photo
      }
      nextToken
    }
  }
`;

export const gamesByAwayTeam = /* GraphQL */ `
  query gamesByAwayTeam(
    $awayTeamId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelGameFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gamesByAwayTeam(
      awayTeamId: $awayTeamId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        awayTeam {
          id
          logo
          name
        }
        homeTeam {
          id
          logo
          name
        }
        homeGoals
        awayGoals
        statusDescription
        status
        id
        kickOffTime
        timestamp
        updatedAt
      }
      nextToken
    }
  }
`;
export const gamesByHomeTeam = /* GraphQL */ `
  query gamesByHomeTeam(
    $homeTeamId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelGameFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gamesByHomeTeam(
      homeTeamId: $homeTeamId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        awayTeam {
          id
          logo
          name
        }
        homeTeam {
          id
          logo
          name
        }
        homeGoals
        awayGoals
        statusDescription
        status
        id
        kickOffTime
        timestamp
        updatedAt
      }
      nextToken
    }
  }
`;
export const getGameInfo = /* GraphQL */ `
  query getGameInfo($id: ID!) {
    getGameInfo: getGame(id: $id) {
      id
      competitionId
      homeTeam {
        id
        name
        logo
      }
      awayTeam {
        id
        name
        logo
      }
      date
      kickOffTime
      timestamp
      status
      statusDescription
      awayGoals
      homeGoals
      elapsedTime
    }
  }
`;
export const getGame = /* GraphQL */ `
  query GetGame($id: ID!) {
    getGame(id: $id) {
      id
      # stageId
      # stage {
      #   id
      #   seasonId
      competitionId
      stage {
        season {
          # id
          # competitionId
          year
          # startDate
          # endDate
          # active
          # apiFootballComCoverage
          standings
          # createdAt
          updatedAt
        }
      }
      competition {
        #   id
        name
        type
        #   country
        logo
        #   countryCode
        #   createdAt
        #   updatedAt
      }
      #   sequence
      #   name
      #   status
      #   games {
      #     nextToken
      #   }
      #   createdAt
      #   updatedAt
      # }
      # competitionId
      # competition {
      #   id
      #   name
      #   type
      #   country
      #   logo
      #   countryCode
      #   createdAt
      #   updatedAt
      # }
      # homeTeamId
      homeTeam {
        id
        name
        # country
        logo
        teamStats {
          items {
            id
            teamId
            competitionId
            goalsFor
            goalsAgainst
            form
            fixtures
            topGoalAssists
          }
        }
      }
      # awayTeamId
      awayTeam {
        id
        name
        # country
        logo
        teamStats {
          items {
            id
            teamId
            competitionId
            goalsFor
            goalsAgainst
            form
            fixtures
            topGoalAssists
          }
        }
      }
      venueName
      date
      kickOffTime
      timestamp
      status
      statusDescription
      awayGoals
      homeGoals
      elapsedTime
      referee
      winner
      events
      gameStats
      playerStats
      captains
      lineups
      headToHead
      updatedAt
    }
  }
`;
export const listGames = /* GraphQL */ `
  query ListGames($filter: ModelGameFilterInput, $limit: Int, $nextToken: String) {
    listGames(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        stageId
        stage {
          id
          seasonId
          competitionId
          sequence
          name
          status
          createdAt
          updatedAt
        }
        competitionId
        topGamesId
        competition {
          id
          name
          type
          country
          logo
          countryCode
          priority
          createdAt
          updatedAt
        }
        homeTeamId
        homeTeam {
          id
          name
          country
          logo
          createdAt
          updatedAt
        }
        awayTeamId
        awayTeam {
          id
          name
          country
          logo
          createdAt
          updatedAt
        }
        venueName
        date
        kickOffTime
        timestamp
        status
        statusDescription
        priority
        awayGoals
        homeGoals
        elapsedTime
        referee
        winner
        events
        gameStats
        playerStats
        lineups
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStage = /* GraphQL */ `
  query GetStage($id: ID!) {
    getStage(id: $id) {
      id
      seasonId
      competitionId
      season {
        id
        competitionId
        competition {
          id
          name
          type
          country
          logo
          countryCode
          priority
          createdAt
          updatedAt
        }
        year
        startDate
        endDate
        active
        stages {
          nextToken
        }
        apiFootballComCoverage
        standings
        createdAt
        updatedAt
      }
      competition {
        id
        name
        type
        seasons {
          nextToken
        }
        country
        logo
        countryCode
        priority
        createdAt
        updatedAt
      }
      sequence
      name
      status
      games {
        items {
          id
          stageId
          competitionId
          topGamesId
          homeTeamId
          awayTeamId
          venueName
          date
          kickOffTime
          timestamp
          status
          statusDescription
          priority
          awayGoals
          homeGoals
          elapsedTime
          referee
          winner
          events
          gameStats
          playerStats
          lineups
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listStages = /* GraphQL */ `
  query ListStages($filter: ModelStageFilterInput, $limit: Int, $nextToken: String) {
    listStages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        seasonId
        competitionId
        season {
          id
          competitionId
          year
          startDate
          endDate
          active
          apiFootballComCoverage
          standings
          createdAt
          updatedAt
        }
        competition {
          id
          name
          type
          country
          logo
          countryCode
          priority
          createdAt
          updatedAt
        }
        sequence
        name
        status
        games {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSeason = /* GraphQL */ `
  query GetSeason($id: ID!) {
    getSeason(id: $id) {
      id
      competitionId
      competition {
        id
        name
        type
        seasons {
          nextToken
        }
        country
        logo
        countryCode
        priority
        createdAt
        updatedAt
      }
      year
      startDate
      endDate
      active
      stages {
        items {
          id
          seasonId
          competitionId
          sequence
          name
          status
          createdAt
          updatedAt
        }
        nextToken
      }
      apiFootballComCoverage
      standings
      createdAt
      updatedAt
    }
  }
`;
export const listSeasons = /* GraphQL */ `
  query ListSeasons($filter: ModelSeasonFilterInput, $limit: Int, $nextToken: String) {
    listSeasons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        competitionId
        competition {
          id
          name
          type
          country
          logo
          countryCode
          priority
          createdAt
          updatedAt
        }
        year
        startDate
        endDate
        active
        stages {
          nextToken
        }
        apiFootballComCoverage
        standings
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompetition = /* GraphQL */ `
  query GetCompetition($id: ID!) {
    getCompetition(id: $id) {
      id
      name
      type
      seasons {
        items {
          id
          competitionId
          year
          startDate
          endDate
          active
          apiFootballComCoverage
          standings
          createdAt
          updatedAt
        }
        nextToken
      }
      country
      logo
      countryCode
      priority
      createdAt
      updatedAt
    }
  }
`;
export const listCompetitions = /* GraphQL */ `
  query listCompetitions($filter: ModelCompetitionFilterInput, $limit: Int, $nextToken: String) {
    listCompetitions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        country
        logo
        priority
      }
      nextToken
    }
  }
`;
export const getTopGames = /* GraphQL */ `
  query GetTopGames($id: ID!) {
    getTopGames(id: $id) {
      id
      games {
        items {
          id
          stageId
          competitionId
          topGamesId
          homeTeamId
          awayTeamId
          venueName
          date
          kickOffTime
          timestamp
          status
          statusDescription
          priority
          awayGoals
          homeGoals
          elapsedTime
          referee
          winner
          events
          gameStats
          playerStats
          lineups
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listTopGamess = /* GraphQL */ `
  query listTopGamess($filter: ModelGameFilterInput, $limit: Int, $nextToken: String) {
    listTopGamess {
      items {
        id
        games(filter: $filter, limit: $limit, nextToken: $nextToken) {
          items {
            id
            competitionId
            topGamesId
            competition {
              id
              name
              type
              country
              logo
              priority
            }
            homeTeam {
              name
              logo
            }
            awayTeam {
              name
              logo
            }
            date
            kickOffTime
            timestamp
            status
            statusDescription
            priority
            awayGoals
            homeGoals
            elapsedTime
            winner
          }
          nextToken
        }
        createdAt
        updatedAt
      }
    }
  }
`;
export const gamesByCompetition = /* GraphQL */ `
  query GamesByCompetition(
    $competitionId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelGameFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gamesByCompetition(
      competitionId: $competitionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        stageId
        stage {
          id
          seasonId
          competitionId
          sequence
          name
          status
          createdAt
          updatedAt
        }
        competitionId
        topGamesId
        competition {
          id
          name
          type
          country
          logo
          countryCode
          priority
          createdAt
          updatedAt
        }
        homeTeamId
        homeTeam {
          id
          name
          country
          logo
          createdAt
          updatedAt
        }
        awayTeamId
        awayTeam {
          id
          name
          country
          logo
          createdAt
          updatedAt
        }
        venueName
        date
        kickOffTime
        timestamp
        status
        statusDescription
        priority
        awayGoals
        homeGoals
        elapsedTime
        referee
        winner
        events
        gameStats
        playerStats
        lineups
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const gamesByDate = /* GraphQL */ `
  query GamesByDate(
    $date: AWSDate
    $sortDirection: ModelSortDirection
    $filter: ModelGameFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gamesByDate(
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        competitionId
        competition {
          id
          name
          type
          country
          logo
          priority
        }
        homeTeam {
          name
          logo
        }
        awayTeam {
          name
          logo
        }
        date
        kickOffTime
        timestamp
        status
        statusDescription
        priority
        awayGoals
        homeGoals
        elapsedTime
        winner
      }
      nextToken
    }
  }
`;
export const gamesByStatus = /* GraphQL */ `
  query GamesByStatus(
    $status: StatusEnum
    $sortDirection: ModelSortDirection
    $filter: ModelGameFilterInput
    $limit: Int
    $nextToken: String
  ) {
    gamesByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        competitionId
        competition {
          id
          name
          type
          country
          logo
          countryCode
          priority
        }
        homeTeam {
          name
          logo
        }
        awayTeam {
          name
          logo
        }
        date
        kickOffTime
        timestamp
        status
        statusDescription
        priority
        awayGoals
        homeGoals
        elapsedTime
        winner
      }
      nextToken
    }
  }
`;
export const stagesByStatus = /* GraphQL */ `
  query StagesByStatus(
    $status: String
    $sortDirection: ModelSortDirection
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    stagesByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seasonId
        competitionId
        season {
          id
          competitionId
          year
          startDate
          endDate
          active
          apiFootballComCoverage
          standings
          createdAt
          updatedAt
        }
        competition {
          id
          name
          type
          country
          logo
          countryCode
          priority
          createdAt
          updatedAt
        }
        sequence
        name
        status
        games {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const stagesByCompIdStatus = /* GraphQL */ `
  query StagesByCompIdStatus(
    $competitionId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    stagesByCompIdStatus(
      competitionId: $competitionId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seasonId
        competitionId
        season {
          id
          competitionId
          year
          startDate
          endDate
          active
          # apiFootballComCoverage
          standings
          topScorers
          topAssists
          topScorers
          topAssists
          topShotsOnTarget
          topDribbles
          topTotalPasses
          topKeyPasses
          topDuels
          topTackles
          topBlocks
          topInterceptions
          topGkSaves
          topYellowCards
          topRedCards
          # createdAt
          updatedAt
        }
        competition {
          id
          name
          type
          country
          logo
        }
        sequence
        name
        status
        games {
          items {
            id
            competitionId
            homeTeam {
              id
              name
              logo
            }
            awayTeam {
              id
              name
              logo
            }
            date
            kickOffTime
            timestamp
            status
            statusDescription
            awayGoals
            homeGoals
            elapsedTime
            winner
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const stagesByCompIdSequence = /* GraphQL */ `
  query StagesByCompIdSequence(
    $competitionId: ID
    $sequence: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    stagesByCompIdSequence(
      competitionId: $competitionId
      sequence: $sequence
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seasonId
        competitionId
        sequence
        name
        status
        games {
          items {
            id
            homeTeam {
              name
              logo
            }
            awayTeam {
              name
              logo
            }
            date
            kickOffTime
            timestamp
            status
            statusDescription
            awayGoals
            homeGoals
            elapsedTime
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
